var React = require('react');

function ArrowRight (props) {
    return React.createElement("svg",props,React.createElement("g",{"stroke":"currentColor","fill":"none","fillRule":"evenodd"},[React.createElement("path",{"d":"M7.5.05L12.45 5 7.5 9.95","key":0}),React.createElement("path",{"d":"M11.5 5H.5","strokeLinecap":"square","key":1})]));
}

ArrowRight.defaultProps = {"viewBox":"0 0 13 10"};

module.exports = ArrowRight;

ArrowRight.default = ArrowRight;
